import React from 'react';

const PrivaryTax = () => {
    return (
        <div className="privacy-policy-content">
        <h3>개인정보처리방침</h3>
        <p>안세회계법인 (이하 "회사" 이라 함)는 귀하의 개인정보보호를 매우 중요시하며, 『개인정보보호법』을 준수하고 있습니다.</p>
        <p>이 개인정보취급방침의 순서는 다음과 같으며, 본 방침은 2021 년 6 월 1 일 부터 시행됩니다.</p>

        <ol>
          <li>개인정보 수집 · 이용 목적, 항목, 방법</li>
          <li>개인정보 보유 · 이용기간, 파기절차, 파기방법</li>
          <li>개인정보를 제 3자에게 제공하는 경우, 제공 받는 자의 성명, 이용 목적, 제공항목</li>
          <li>취급 위탁 업무 내용, 수탁자</li>
          <li>이용자 및 법정대리인 권리와 그 행사방법</li>
          <li>자동수집장치 설치, 운영, 거부</li>
          <li>개인정보관리책임자 성명(또는 부서), 연락처</li>
        </ol>

        <h4>1. 개인정보 수집 · 이용 목적, 항목, 방법</h4>
        <p>- 이용목적 : 고객문의 처리</p>
        <p>- 수집항목 : 성명, 나이, 연락처, 상담내용</p>
        <p>- 수집방법 : 홈페이지 내 온라인 간편문의 양식</p>

        <h4>2. 개인정보 보유 · 이용기간, 파기절차, 파기방법</h4>
        <p>- 보유 · 이용기간 : 1년</p>
        <p>- 파기절차 : 목적 달성 후 DB 이동 후 1년 저장 후 파기</p>
        <p>- 파기방법 : 전자적 파일 삭제 및 문서 소각</p>

        <h4>3. 개인정보를 제 3자에게 제공하는 경우</h4>
        <p>회사는 개인정보를 제3자에게 제공하지 않습니다.</p>

        <h4>4. 취급 위탁 업무 내용, 수탁자</h4>
        <p>회사는 서비스 향상을 위해 개인정보 수집을 위탁할 수 있으며, 관계법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고 이를 공개합니다.</p>

        <h4>5. 이용자 및 법정대리인 권리와 그 행사방법</h4>
        <p>- 이용자는 언제든지 등록된 개인정보를 수정하거나 삭제 요청할 수 있습니다.</p>
        <p>- 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 조치하겠습니다.</p>

        <h4>6. 자동수집장치 설치, 운영, 거부</h4>
        <p>- 쿠키를 이용하여 맞춤형 서비스를 제공합니다.</p>
        <p>- 이용자는 브라우저 설정을 통해 쿠키를 거부할 수 있습니다.</p>

        <h4>7. 개인정보관리책임자</h4>
        <p>- 부서 : 온라인 마케팅팀</p>
        <p>- 연락처 : 02-829-7575</p>

        <h4>기타 문의</h4>
        <p>귀하께서는 당 사이트 홈페이지 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.</p>
        <p>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>

        <ul>
          <li>개인분쟁조정위원회 (www.1336.or.kr / 1336)</li>
          <li>정보보호마크인증위원회 (www.eprivacy.or.kr / 02-580-0533~4)</li>
          <li>대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr / 02-3480-3600)</li>
          <li>경찰청 사이버테러대응센터 (www.ctrc.go.kr / 02-392-0330)</li>
        </ul>
      </div>
    );
};

export default PrivaryTax;



